import React from "react";
import "./ProductPage.css";
import productImage from '../assets/img/product.png'; // Import the image

const ProductPage = () => {
  return (
    <div className="container my-5 product-page">
      {/* Header Section */}
      <div className="text-center mb-5">
        <h1 className="fw-bold">Precision. Innovation. Reliability.</h1>
        <p className="description">
          Our <span className="highlight">Digital Infrared Thermal Cameras (DIT)</span> are designed for 
          <span className="highlight"> medical, veterinary,</span> and 
          <span className="highlight"> security applications</span>, offering high-resolution imaging, real-time analysis, 
          and advanced detection capabilities. Discover our range of products and their unique features.
        </p>
      </div>

      {/* Product Section */}
      <div className="row">
        <div className="col-md-6">
          <h2 className="fw-bold">MIDC-CG 320 & CG 640 - DIGITAL INFRARED THERMAL CAMERA</h2>
          <div class="why-thermal-line"></div>
          <p>
            The MIDC-CG 320 & CG 640 are high-performance thermal imaging systems designed for medical diagnostics, research, and veterinary applications. These cameras offer superior image resolution and advanced analytics for accurate thermal imaging.
          </p>
          <h5>Specially Designed For:</h5>
          <ul className="text-start">
            <li>Medical Care</li>
            <li>Equine & Animal Husbandry</li>
          </ul>
        </div>

        <div className="col-md-6">
          <img 
            src={productImage}  // Use the imported image
            alt="Thermal Camera" 
            className="img-fluid rounded product"
          />
        </div>
      </div>

      {/* Features and What's Included */}
      <div className="row mt-5">
        {/* Key Features */}
        <div className="col-md-6">
          <div className="card w-100 p-4 mb-3">
            <h4 className="text-black">Key Features</h4>
            <ul className="text-start">
              <li>Fully Radiometric</li>
              <li>640x480 High-End Resolution</li>
              <li>NTSC/PAL Compatible</li>
              <li>Real-Time Analyzer</li>
              <li>Hot/Cold Spot Tracker</li>
              <li>Temperature Data for All Pixels</li>
              <li>Various Color Palettes & Histogram Scale</li>
            </ul>
          </div>
        </div>

        {/* What's Included */}
        <div className="col-md-6">
          <div className="card w-100 p-4">
            <h4 className="text-black">What's Included</h4>
            <ul className="text-start">
              <li>Apple INC. USA Software</li>
              <li>Clinical Manuals</li>
              <li>Tripod Stand, Laptop</li>
              <li>Training by Certified Clinical Thermographer (Level 1, USA)</li>
              <li>Online Interpretation & Reporting by Radiology Experts</li>
              <li>One Year Warranty</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center mt-4">
        <button className="btn gradient-btn">Request a Demo ➡</button>
      </div>
    </div>
  );
};

export default ProductPage;
